const messages = {
  en: {
    related: 'Related Topics Other Users Found Helpful',
    mostSeen: 'Most Seen Tutorials: ',
    guides: 'Troubleshooting Guides: ',
    faqs: 'Frequently Asked Questions: ',
    tutorials: 'Tutorials: ',
    videos: 'Videos: ',
    noContent: 'No other content',
    suggested: 'Suggested Tutorials: ',
    other: 'Other Devices'
  },
  'es-ud': {
    tutorials: 'Tutoriales: ',
    guides: 'Guías de Solución de Problemas: ',
    related: 'Temas Relacionados que Resultaron Útiles a Otros Usuarios',
    noContent: 'Ningún otro contenido',
    mostSeen: 'Tutoriales Más Vistos: ',
    faqs: 'Preguntas Frecuentes: ',
    suggested: 'Tutoriales Sugeridos: ',
    videos: 'Videos: ',
    other:'Otros Dispositivos'
  },
  es: {
    tutorials: 'Tutoriales: ',
    guides: 'Guías de Solución de Problemas: ',
    related: 'Temas Relacionados que Resultaron Útiles a Otros Usuarios',
    noContent: 'Ningún otro contenido',
    mostSeen: 'Tutoriales Más Vistos: ',
    faqs: 'Preguntas Frecuentes: ',
    suggested: 'Tutoriales Sugeridos: ',
    videos: 'Videos: ',
    other:'Otros Dispositivos'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/containers/RelatedSidebar/messages.js